import axios from 'axios';

// API 기본 URL
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Axios 인스턴스 생성
const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 요청 인터셉터: 토큰 자동 추가
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // 개발 환경에서 tenantId 헤더 추가
    // academyCode를 우선 사용, 없으면 tenantId, 둘 다 없으면 'default'
    const academyCode = localStorage.getItem('academyCode') || localStorage.getItem('tenantId') || 'default';
    config.headers['x-tenant-id'] = academyCode;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터: 에러 처리
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // 401 에러: 로그인 필요
    if (error.response?.status === 401) {
      localStorage.removeItem('token');

      // 로그인 페이지가 아니면 리다이렉트
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

// ============ Auth API ============
export const authAPI = {
  login: (email, password) =>
    api.post('/api/auth/login', { email, password }),

  register: (data) =>
    api.post('/api/auth/register', data),

  me: () =>
    api.get('/api/auth/me'),

  changePassword: (currentPassword, newPassword) =>
    api.put('/api/auth/password', { currentPassword, newPassword })
};

// ============ Users API ============
export const usersAPI = {
  list: (params) =>
    api.get('/api/users', { params }),

  students: (params) =>
    api.get('/api/users/students', { params }),

  get: (id) =>
    api.get(`/api/users/${id}`),

  create: (data) =>
    api.post('/api/users', data),

  update: (id, data) =>
    api.put(`/api/users/${id}`, data),

  delete: (id) =>
    api.delete(`/api/users/${id}`),

  bulkCreate: (users) =>
    api.post('/api/users/bulk', { users })
};

// ============ Attendance API ============
export const attendanceAPI = {
  checkIn: (studentId) =>
    api.post('/api/attendance/check-in', { studentId }),

  checkOut: (studentId) =>
    api.post('/api/attendance/check-out', { studentId }),

  byDate: (date) =>
    api.get('/api/attendance/by-date', { params: { date } }),

  byStudent: (studentId, params) =>
    api.get(`/api/attendance/by-student/${studentId}`, { params })
};

// ============ Lessons API ============
export const lessonsAPI = {
  list: (params) =>
    api.get('/api/lessons', { params }),

  get: (id) =>
    api.get(`/api/lessons/${id}`),

  create: (data) =>
    api.post('/api/lessons', data),

  update: (id, data) =>
    api.put(`/api/lessons/${id}`, data),

  send: (id) =>
    api.post(`/api/lessons/${id}/send`)
};

// ============ Points API ============
export const pointsAPI = {
  balance: () =>
    api.get('/api/points'),

  history: (params) =>
    api.get('/api/points/history', { params }),

  requestCharge: (data) =>
    api.post('/api/points/charge-request', data)
};

export default api;
